import React from 'react';
import Swatch, { SwatchProps } from '../color-swatch';
import { ColorResult, color as handleColor, hexToHsva, HsvaColor, hsvaToHex, validHex } from '../utils/color-convert';
import Point from './Point';

export interface CirclePickerProps extends Omit<SwatchProps, 'color' | 'onChange'> {
    color?: string | HsvaColor;
    onChange?: (color: ColorResult) => void;
}

const CirclePicker = React.forwardRef<HTMLDivElement, CirclePickerProps>((props, ref) => {
    const {
        prefixCls = 'c-color-circle-picker',
        className,
        color,
        colors = [],
        rectProps = {},
        onChange,
        ...other
    } = props;
    const hsva = (typeof color === 'string' && validHex(color) ? hexToHsva(color) : color || {}) as HsvaColor;
    const hex = color ? hsvaToHex(hsva) : '';
    return (
        <Swatch
            ref={ref}
            colors={colors}
            color={hex}
            {...other}
            className={[prefixCls, className].filter(Boolean).join(' ')}
            rectRender={({ ...props }) => <Point {...props} rectProps={rectProps} />}
            onChange={(hsvColor) => {
                onChange && onChange(handleColor(hsvColor));
            }}
        />
    );
});

CirclePicker.displayName = 'CirclePicker';

export default CirclePicker;
